import { Heading, Panel } from '@savgroup-front-common/core';

const CommandePage = () => {
  return (
    <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
      <Heading level={1}>
        Commandes
      </Heading>
      <div style={{ marginTop: '2rem' }}>
        <Panel>
          <Heading level={2}>
            Liste des Commandes
          </Heading>
          <p>Contenu de la page Commandes à venir...</p>
        </Panel>
      </div>
    </div>
  );
};

export default CommandePage;
